import { render, staticRenderFns } from "./HomeTransactionList.vue?vue&type=template&id=2e36be9c&scoped=true&"
import script from "./HomeTransactionList.vue?vue&type=script&lang=js&"
export * from "./HomeTransactionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36be9c",
  null
  
)

export default component.exports